// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kh-0";
export var fileCarousel = "_kh-2";
export var removeFileButton = "_kh-1";